<template>
	<AppDialog :dialogName="dialogName" :max-width="570">
		<div class="px-6 py-6">
			<div class="slot-title">Change your password</div>
			<v-form v-model="isFormValid" ref="passwordChangeForm" @submit.prevent="sendPasswordChange" class="user-input-box">
				<SignupTextField
					label="Current password"
					v-model="currentPassword"
					type="password"
					autofocus
					iconName="input-key"
					placeholder="Type your current password"
				>
				</SignupTextField>
				<PasswordTextField
					v-model="password"
					:password="password"
					label="Enter password"
					@password-valid-update="onPasswordValidationUpdate"
				/>
				<SignupTextField
					type="password"
					v-model="password2"
					iconName="input-key"
					label="Verify password"
					:rules="passwordConfirmationRule"
					placeholder="Retype new password"
				/>
				<v-btn :loading="submittingForm" :disabled="password !== password2 || !isPasswordValid" color="primary" type="submit"
					>Change Password</v-btn
				>
			</v-form>
		</div>
	</AppDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppDialog from '../../AppDialog/AppDialog';
import SignupTextField from '../../../../views/userRegistration/components/SignupTextField';
import PasswordTextField from '../../../../views/userRegistration/components/PasswordTextField';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'ChangePassword',
	components: {
		AppDialog,
		SignupTextField,
		PasswordTextField,
	},
	props: { dialogName: { type: String } },
	mixins: [],
	computed: {
		...mapGetters(['user']),
		passwordConfirmationRule() {
			return [() => this.password === this.password2 || 'Password must match'];
		},
	},
	methods: {
		...mapActions(['changePassword']),
		onPasswordValidationUpdate(newVal) {
			this.isPasswordValid = newVal;
		},
		async sendPasswordChange() {
			this.$refs.passwordChangeForm.validate();
			if (this.isFormValid && this.user) {
				this.submittingForm = true;
				try {
					await this.changePassword({
						userID: this.user.id,
						currentPassword: this.currentPassword,
						password: this.password,
						password2: this.password2,
					});
					this.$toast.success(`successfully changed password`);
					AppDialogManagerService.closeCurrentDialog();
				} catch (error) {
					if (error.response?.data?.error?.msg) {
						this.$toast.error(`failed to change password: ${error.response.data.error.msg}`);
					} else {
						this.$toast.error(`failed to change password, please try again`);
					}
				}
				this.submittingForm = false;
			}
		},
	},
	data: () => ({
		isFormValid: false,
		submittingForm: false,
		isPasswordValid: false,
		password: '',
		password2: '',
		currentPassword: '',
	}),
};
</script>

<style scoped>
.slot-title {
	margin: 30px 0 40px;
	font-size: 20px;
}
</style>
